export default "dist/images/block-feature-overlap5.75f68bc.png";